import { fetchProgramDeliverablesBundle } from './accountProgramDeliverables';
import { isHiringServiceItem } from './programPricing';

/**
 * Compute a client's Hiring deliverable balance — same rules as
 * useHiringDeliverable, so "unused" here matches the portal's gating.
 * Shared by the CRM HR Fulfillment Kanban and the Hiring Fulfillment card on
 * the HR team's Dashboard.
 */
export const computeHiringBalance = async (account) => {
  try {
    const { programItems } = await fetchProgramDeliverablesBundle(account);
    const hiringItems = (programItems || []).filter(isHiringServiceItem);
    const limit = hiringItems.reduce((sum, i) => sum + (Number(i.programQuantity) || 0), 0);
    const used = hiringItems.reduce((sum, i) => sum + (Number(i.completed) || 0), 0);
    return { hasDeliverable: hiringItems.length > 0, limit, used, remaining: Math.max(0, limit - used) };
  } catch (error) {
    console.error('Error computing hiring balance for account', account?.id, error);
    return { hasDeliverable: false, limit: 0, used: 0, remaining: 0 };
  }
};

export default computeHiringBalance;
